import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import TransactionInsightsView from '../../components/Admin/AccountTransactions/TransactionInsightsView';
import {
  MOCK_ACCOUNT_CONTEXT,
  MOCK_ACCOUNT_ID,
  MOCK_SUMMARY,
  MOCK_TRANSACTIONS,
} from '../../components/Admin/AccountTransactions/mock/mockTransactionData';

const getSystemRole = (): string | null => {
  try {
    return sessionStorage.getItem('systemRole');
  } catch {
    return null;
  }
};

const AccountTransactionsMockPage: React.FC = () => {
  const navigate = useNavigate();

  if (getSystemRole() !== 'system_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <TransactionInsightsView
      accountId={MOCK_ACCOUNT_ID}
      accountContext={MOCK_ACCOUNT_CONTEXT}
      transactions={MOCK_TRANSACTIONS}
      summary={MOCK_SUMMARY}
      onBack={() => navigate('/customer-details')}
    />
  );
};

export default AccountTransactionsMockPage;
